// src/theme/ThemeContext.jsx 
import { createContext, useContext } from "react";
import { DEFAULT_THEME } from "../services/gymTheme.service";

export const ThemeContext = createContext({
  theme: DEFAULT_THEME,
  isDefaultTheme: true,
  isThemeReady: false,
});

export const useTheme = () => useContext(ThemeContext);